module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-right-3.6b9c82ca.png";